/*
 * Copyright (c) 2025-2026 Aegis AO Soft LLC and Alexander Orlov.
 * 34 Middletown Ave, Atlantic Highlands, NJ 07716
 *
 * THIS SOFTWARE IS THE CONFIDENTIAL AND PROPRIETARY INFORMATION OF
 * Aegis AO Soft LLC and Alexander Orlov.
 *
 * This code may be used, reproduced, modified, or distributed ONLY with the
 * prior written permission of Aegis AO Soft LLC / Alexander Orlov.
 *
 * Author: Alexander Orlov
 * Aegis AO Soft LLC
 */


import apiClient from './client';

export interface EmailRelayAlias {
  configured: boolean;
  domain: string;
  slug?: string;
  publicAddress?: string;
  forwardTo?: string;
  isEnabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface EmailRelayConversation {
  id: string;
  contactEmail: string;
  lastSubject: string | null;
  inboundCount: number;
  replyCount: number;
  createdAt: string;
  lastInboundAt: string;
  lastReplyAt: string | null;
}

export const emailRelayApi = {
  getAlias: async (ownerId?: string): Promise<EmailRelayAlias> => {
    const r = await apiClient.get<EmailRelayAlias>('/email-relay/alias', {
      params: ownerId ? { ownerId } : undefined,
    });
    return r.data;
  },

  saveAlias: async (slug: string, forwardTo: string, isEnabled?: boolean, ownerId?: string): Promise<EmailRelayAlias> => {
    const r = await apiClient.put<EmailRelayAlias>('/email-relay/alias',
      { slug, forwardTo, isEnabled },
      { params: ownerId ? { ownerId } : undefined },
    );
    return r.data;
  },

  listConversations: async (ownerId?: string): Promise<EmailRelayConversation[]> => {
    const r = await apiClient.get<EmailRelayConversation[]>('/email-relay/conversations', {
      params: ownerId ? { ownerId } : undefined,
    });
    return r.data;
  },

  compose: async (to: string, subject: string, body: string): Promise<{ sent: boolean; conversationToken: string | null }> => {
    const r = await apiClient.post<{ sent: boolean; conversationToken: string | null }>(
      '/email-relay/compose',
      { to, subject, body }
    );
    return r.data;
  },
};
